"use client"

import { useRef, useState } from "react"
import { SocialLoginButtons } from "@/components/auth/SocialLoginButtons"
import { trackEvent } from "@/lib/analytics"
import { useInViewportImpression } from "@/hooks/use-visible-impression"

export interface ScanRecoveryAccountOfferProps {
  redirectTo: string
  onBeforeRedirect: () => void
  mode: 'identify' | 'diagnose'
  reason: 'photo' | 'network' | 'save' | 'server'
  analysisId?: string | null
  funnelId?: string | null
}

export function ScanRecoveryAccountOffer({
  redirectTo, onBeforeRedirect, mode, reason, analysisId, funnelId,
}: ScanRecoveryAccountOfferProps) {
  const [error, setError] = useState<string | null>(null)
  const impressions = useRef(new Set<string>()).current
  const offerRef = useInViewportImpression(impressions, true, `${mode}:${reason}`, () => {
    trackEvent('scan_recovery_account_shown', { mode, reason, analysis_id: analysisId, funnel_id: funnelId })
  })

  return (
    <div ref={offerRef} className="mt-6 text-center">
      <p className="text-sm font-semibold text-gray-900 mb-3">
        Create a free account to track your lawn
      </p>
      <SocialLoginButtons
        compact
        placement="scan_recovery"
        redirectTo={redirectTo}
        analysisContext={{ analysisId, funnelId }}
        onBeforeRedirect={() => {
          setError(null)
          onBeforeRedirect()
          trackEvent('scan_recovery_account_clicked', { mode, reason, analysis_id: analysisId, funnel_id: funnelId })
          return { mode, recovery_reason: reason }
        }}
        onError={(cause) => setError(cause.message || 'Sign-in did not start. You can still retry your scan.')}
      />
      {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
    </div>
  )
}
